import {lifecycle} from 'recompose';

export default lifecycle({

  componentDidMount() {
      // Check if user has active session (cookie-based)
      // Only check once to prevent infinite loops when component remounts
      if (!this.props.sessionChecked) {
          this.props.onCheckSession();
      }
  }

});